import { NOT_ENOUGH_RIGHTS } from '../actions/notEnoughRights';

const initialState = false;

export default function(state = initialState, action) {
  switch (action.type) {
    case NOT_ENOUGH_RIGHTS:
      return action.payload;
    default:
      return state;
  }
}
